import _extends from "@babel/runtime-corejs2/helpers/extends";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Avatar from './Avatar';
import NavDropdown from './NavDropdown';
var TRUNCATE_LENGTH = 25;

var AccountDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(AccountDropdown, _React$Component);

  var _super = _createSuper(AccountDropdown);

  function AccountDropdown() {
    var _this;

    _classCallCheck(this, AccountDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showTooltip: !_this.props.hasMultipleOrgs
    });

    return _this;
  }

  _createClass(AccountDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hasMultipleOrgs = this.props.hasMultipleOrgs;
      var organizationName = this.organizationName();
      var userName = this.userName();
      var isOverflowing = userName.length > TRUNCATE_LENGTH || organizationName.length > TRUNCATE_LENGTH;

      if (hasMultipleOrgs && isOverflowing) {
        this.setState({
          showTooltip: true
        });
      }
    }
  }, {
    key: "organizationName",
    value: function organizationName() {
      var organization = this.props.organization;
      return organization.name || "Account ".concat(organization.id);
    }
  }, {
    key: "userName",
    value: function userName() {
      var _this$props = this.props,
          email = _this$props.email,
          userName = _this$props.userName;
      return userName.length ? userName : email;
    }
  }, {
    key: "truncate",
    value: function truncate(str) {
      if (str.length > TRUNCATE_LENGTH) {
        var truncated = str.substring(0, TRUNCATE_LENGTH).trim(); // remove last character if it's a period

        if (truncated.slice(-1) === '.') {
          truncated = truncated.substring(0, truncated.length - 1);
        }

        return truncated + '…';
      } else {
        return str;
      }
    }
  }, {
    key: "accountDetails",
    value: function accountDetails(truncate) {
      var organizationName = this.organizationName();
      var userName = this.userName();
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "current-user"
      }, truncate ? this.truncate(userName) : userName), /*#__PURE__*/React.createElement("div", {
        className: "current-organization"
      }, truncate ? this.truncate(organizationName) : organizationName));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          email = _this$props2.email,
          hasMultipleOrgs = _this$props2.hasMultipleOrgs,
          inverted = _this$props2.inverted,
          isActive = _this$props2.isActive,
          innerRef = _this$props2.innerRef,
          userName = _this$props2.userName,
          withInitials = _this$props2.withInitials,
          unified = _this$props2.unified,
          unifiedError = _this$props2.unifiedError;
      var withContext = hasMultipleOrgs || unified && !unifiedError;
      return /*#__PURE__*/React.createElement(NavDropdown, {
        className: classNames('cloud-ui-account', {
          'with-context': withContext,
          unified: unified
        }),
        inverted: inverted,
        isActive: isActive,
        label: /*#__PURE__*/React.createElement("div", {
          className: "avatar-container"
        }, /*#__PURE__*/React.createElement(Avatar, {
          email: email,
          userName: userName,
          withInitials: withInitials
        }), withContext && /*#__PURE__*/React.createElement("div", {
          className: "account-details"
        }, this.accountDetails(!unified))),
        pinned: true,
        position: "bottom right",
        tooltip: !unifiedError && this.state.showTooltip ? /*#__PURE__*/React.createElement("div", {
          className: "cloud-ui-account-tooltip"
        }, unified ? this.props.email : this.accountDetails()) : null,
        "data-qa": "nav-account-menu",
        ref: innerRef
      }, children);
    }
  }]);

  return AccountDropdown;
}(React.Component);

_defineProperty(AccountDropdown, "propTypes", {
  email: PropTypes.string.isRequired,
  hasMultipleOrgs: PropTypes.bool,
  inverted: PropTypes.bool,
  isActive: PropTypes.bool,
  organization: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  userName: PropTypes.string,
  unified: PropTypes.bool,
  unifiedError: PropTypes.bool
});

_defineProperty(AccountDropdown, "defaultProps", {
  userName: ''
});

export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AccountDropdown, _extends({
    innerRef: ref
  }, props));
});